var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKazakhLit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 63,
    viewBox: "0 0 88 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6079 4.75688C46.1188 2.8254 41.8812 2.8254 38.3921 4.75687L18.1598 15.9569C15.528 17.4138 13.8947 20.1847 13.8947 23.1929V24.4794H74.1053V23.1929C74.1053 20.1847 72.472 17.4138 69.8402 15.9569L49.6079 4.75688ZM74.1053 27.7876H13.8947V46.4557H33.8767V42.6276C33.8767 39.8869 36.0984 37.6652 38.8391 37.6652H49.1609C51.9016 37.6652 54.1233 39.8869 54.1233 42.6276V46.4557H74.1053V27.7876ZM74.1053 49.764H54.1233V59.6416H74.1053V49.764ZM77.4135 59.6416V23.1929C77.4135 18.9815 75.127 15.1022 71.4425 13.0625L51.2101 1.86249C46.7241 -0.620829 41.2759 -0.620832 36.7899 1.86249L16.5575 13.0625C12.873 15.1022 10.5865 18.9815 10.5865 23.1929V59.6416H1.65414C0.740582 59.6416 0 60.3821 0 61.2957C0 62.2092 0.740582 62.9498 1.65414 62.9498H86.3459C87.2594 62.9498 88 62.2092 88 61.2957C88 60.3821 87.2594 59.6416 86.3459 59.6416H77.4135ZM13.8947 59.6416H33.8767V49.764H13.8947V59.6416ZM37.185 59.6416H50.815V42.6276C50.815 41.714 50.0745 40.9735 49.1609 40.9735H38.8391C37.9255 40.9735 37.185 41.714 37.185 42.6276V59.6416Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKazakhLit);
export default __webpack_public_path__ + "static/media/KazakhLit.6a84c3e2.svg";
export { ForwardRef as ReactComponent };